import styled from "styled-components/macro";
import { Link } from "react-router-dom";

export const ServicePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;

  @media (max-width: 1026px) {
    width: 80%;
  }

  img {
    width: 80%;
    margin: 30px;
  }

  p {
    margin: 40px;
  }
`;

export const PageLink = styled(Link)`
  display: flex;
  color: #d3420d;
  font-weight: bold;
  text-decoration: none;
  font-size: 22px;
  margin-bottom: 40px;

  .icon-link {
    font-size: 38px;
  }
`;
